import { useCallback } from 'react';
import { setComplexPaymentPlan, useAppDispatch } from 'src/store';
import {
  setSelectedPeriod,
  setSelectedFamily,
  setSelectedPlanByFamily,
} from 'src/store';
import {
  CanonicalInterval,
  PlanKind,
  PlanFamily,
  PaymentTabs,
} from 'src/types';
import {
  setSelectedPaymentTab,
  setSelectedPlan,
} from 'src/store/slices/paymentControlSlice';

export const usePaymentControlActions = () => {
  const dispatch = useAppDispatch();

  const onSetSelectedPeriod = useCallback(
    (period: CanonicalInterval) => {
      dispatch(setSelectedPeriod(period));
    },
    [dispatch],
  );

  const onSetSelectedFamily = useCallback(
    (planFamily?: PlanFamily) => {
      dispatch(setSelectedFamily(planFamily));
    },
    [dispatch],
  );

  const onSetSelectedPlanByFamily = useCallback(
    ({
      planFamily,
      planKind,
    }: {
      planFamily: PlanFamily;
      planKind: PlanKind;
    }) => {
      dispatch(setSelectedPlanByFamily({ planFamily, planKind }));
    },
    [dispatch],
  );

  const onSetSelectedPlan = useCallback(
    ({ planKind }: { planKind?: PlanKind }) => {
      dispatch(setSelectedPlan({ planKind }));
    },
    [dispatch],
  );

  const onSelectComplexPaymentPlan = useCallback(
    ({
      planFamily,
      planKind,
      period,
    }: {
      planFamily: PlanFamily;
      planKind: PlanKind;
      period: CanonicalInterval;
    }) => {
      dispatch(
        setComplexPaymentPlan({
          planFamily,
          planKind,
          period,
        }),
      );
    },
    [dispatch],
  );

  const onSetSelectedPaymentTab = useCallback(
    (tab: PaymentTabs) => {
      dispatch(setSelectedPaymentTab(tab));
    },
    [dispatch],
  );

  return {
    onSetSelectedPeriod,
    onSetSelectedFamily,
    onSetSelectedPlanByFamily,
    onSelectComplexPaymentPlan,
    onSetSelectedPaymentTab,
    onSetSelectedPlan,
  };
};
